<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div
            class="bank bh bstart"
            @click="go('UserBankSelect',{bankCardNumber:bankInfo.bankCardNumber
        })"
        >
            <div class="ico bg-contain" :style="{backgroundImage: `url('${bankInfo.bankIcon}')`}"></div>
            <div class="b1 fz_34">{{bankInfo.bankName}}&emsp;({{bankNo}})</div>
            <div class="ico-next bg-contain"></div>
        </div>
        <div class="line"></div>
        <validation-observer v-slot="{ invalid }" ref="form" tag="div">
            <div class="exchange-container">
                <div class="bh bstart">
                    <div class="fz_28 c_333 b1">提现车主币(个)</div>
                    <div class="ico-question bg-contain" @click="showRule"></div>
                    <div class="fz_28 c_666" @click="showRule">提现规则</div>
                </div>
                <validation-provider
                    rules="required|min_value:100"
                    name="提现金额"
                    :customMessages="{required:'请输入提现车主币数量',min_value:'最低提现车主币100'}"
                >
                    <input type="hidden" v-model="formData.withdrawPointAmount" />
                </validation-provider>
                <Money
                    ref="money"
                    v-model="formData.withdrawPointAmount"
                    :maxNum="maxNum"
                    placeholder="请输入提现车主币数量"
                    class="money-container fz_70"
                    :disable="isDisable"
                    @disableclick="onDisableClick"
                ></Money>
                <div class="text bh fz_28">
                    <div v-if="message" class="fz_28 c_999" v-html="message"></div>
                    <div class="c_999" v-else>可提现车主币{{maxNum}}个</div>
                    <div class="c_black maxNum" v-if="!isDisable" @click="onExchangeAll">全部提现</div>
                </div>
            </div>
            <div class="fz_28 c_999 message">预计1-3个工作日内到账</div>
            <div class="bh bc footBar">
                <van-button
                    @click="onSaveClick"
                    :class="withdrawClass(invalid)"
                    class="btn btn-goodbuy"
                >
                    <span class="fz_30 btn-span">立即提现</span>
                </van-button>
            </div>
        </validation-observer>
        <van-action-sheet v-model="isDialog" title="确认提现">
            <div class="sheet-content">
                <div class="tc">
                    <span class="fz_65">￥</span>
                    <span class="fz_70 c_black">{{money}}</span>
                </div>
                <div class="points fz_34 bh bbetween">
                    提现车主币(个)
                    <div>{{parseInt(formData.withdrawPointAmount)}}</div>
                </div>
                <div class="money fz_34 bh bbetween">
                    预计到账金额(元)
                    <div class="c_warning">{{money}}</div>
                </div>
                <div class="message c_999 fz_24">预计1-3个工作日内到账</div>
                <div class="bh bc content-footBar">
                    <van-button @click="onExchangeClick" class="btn btn-goodbuy">
                        <span class="fz_30 btn-span">确认提现</span>
                    </van-button>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { mixinValid } from "@/mixin/valid";
import { mixinDialog } from "@/mixin/dialog";
import { exchangeMoney } from "@/api/money";
import Money from "@/components/input/Money";
import util from "@/utils/index";
export default {
    mixins: [user, mixinValid, mixinDialog],
    name: "MoneyExchange",
    components: { Money },
    data() {
        return {
            formData: {
                withdrawPointAmount: ""
            }
        };
    },
    computed: {
        // 提现时当前选中银行卡
        bankInfo() {
            return this.$store.getters["money/selectBank"];
        },
        // 认证信息
        verificationInfo() {
            return this.$store.getters["money/verificationInfo"];
        },
        // 银行卡号
        bankNo() {
            return util.sliceLast(this.bankInfo.bankCardNumber);
        },
        // 用户最大提现金额
        maxPoints() {
            return this.verificationInfo.customerPoints;
        },
        // 用户剩余提现次数
        exchangeCount() {
            return this.verificationInfo.withdrawTimeThisMonth;
        },
        // 当前最大可提现金额
        maxNum() {
            const maxPoints = this.maxPoints;
            return maxPoints > 5000 ? 5000 : Math.floor(maxPoints);
        },
        // 是否禁止提现
        isDisable() {
            // 生产环境不启用
            if (!['prod'].includes(process.env.VUE_APP_CURRENTMODE)) {
                return !this.exchangeCount;
            }
            return this.maxPoints < 100 || !this.exchangeCount;
        },
        // 提现可兑换金额
        money() {
            const money = this.formData.withdrawPointAmount;
            return money ? (money * 0.93).toFixed(2) : 0;
        },
        // 提示消息
        message() {
            const maxPoints = this.maxPoints;
            let message = "";
            if (!this.exchangeCount) {
                message = "<span class='c_red'>当月已达到最大可提现次数</span>";
            } else if (maxPoints < 100) {
                // 可提现金额小于100时
                message = "最低提现车主币<span class='c_999'>100个</span>";
            } else if (maxPoints > 5000) {
                // 可提现金额大于5000时
                message = "最高提现车主币<span class='c_999'>5000个</span>";
            }
            return message;
        }
    },
    watch: {
        // 更新上传银行卡
        bankInfo: {
            handler(v) {
                this.formData.bankCardNumber = v.bankCardNumber;
                this.formData.bankName = v.bankName;
            },
            immediate: true
        }
    },
    methods: {
        // 提现样式
        withdrawClass(invalid) {
            // 生产环境不启用
            if (!['prod'].includes(process.env.VUE_APP_CURRENTMODE)) {
                return ''
            }
            return this.getBtnCls(invalid)
        },
        viewBack() {
            // 返回时置空选择
            this.$store.state.money.selectBank = null;
        },
        // 登录成功
        userLoginend() {
            this.$store.dispatch("money/verificationInfo");
        },
        showRule() {
            this.dialog.alert({
                title: "提现规则",
                message: `最低提现100个车主币，最高提现5000个车主币，自然月内最多提现20次。`,
                confirmButtonText: `好的`,
                messageAlign: "left"
            });
        },
        onExchangeAll() {
            this.formData.withdrawPointAmount = this.maxNum;
        },
        onSaveClick() {
            const me = this;
            if (me.isDisable) {
                me.toast.fail(me.message.replace(/<[^>]+>/gi, ""));
            } else {
                // 生产环境不启用
                if (!['prod'].includes(process.env.VUE_APP_CURRENTMODE)) {
                    me.showDialog();
                    return
                }
                me.validForm().then(() => {
                    me.showDialog();
                });
            }
        },
        onDisableClick() {
            this.toast.fail(this.message.replace(/<[^>]+>/gi, ""));
        },
        onExchangeClick() {
            const me = this,
                formData = me.formData;
            exchangeMoney(formData).then(() => {
                me.refreshMoney();
                me.replaceGo(
                    "MoneyConsequence",
                    Object.assign({}, formData, {
                        money: me.money
                    })
                );
            });
        }
    }
};
</script>

<style scoped lang="scss">
@include img-list("~@/assets/imges/money/", "logo");
.topbar-container {
    background-color: #f7f8f8;
    .bank {
        background-color: #fff;
        padding: 50px 30px;
        .ico {
            width: 42px;
            height: 42px;
            margin-right: 12px;
        }
        .ico-next {
            width: 16px;
            height: 30px;
        }
    }
    .exchange-container {
        background-color: #fff;
        padding: 39px 30px;
        .money-container {
            padding: 38px 0 51px 0;
            border-bottom: 1px solid #dcdcdc;
        }
        .ico-question {
            width: 32px;
            height: 32px;
            margin-right: 12px;
        }
        .text {
            padding-top: 30px;
            .maxNum {
                margin-left: 20px;
            }
        }
    }
    .message {
        padding: 39px 30px 90px 30px;
    }
}
.btn-goodbuy {
    width: 510px;
    height: 76px;
}
.sheet-content {
    padding: 60px 30px 60px 30px;
    .points {
        padding: 60px 0 40px 0;
    }
    .message {
        padding: 29px 0 60px 0;
        border-bottom: 1px solid #dcdcdc;
    }
    .content-footBar {
        margin-top: 60px;
    }
}
</style>
